module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/2-2-2-73e6ad63f42edeb64f0a38459c1dedfe.png";